import { useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import {
  CALENDAR_RULE_NOTE,
  formatCycleDate,
  upcomingCycles,
} from "./payablesCalendar";

const BLUE = "#2563EB";

const TH_STYLE = {
  textAlign: "left", padding: "10px 14px", fontSize: "0.7rem", fontWeight: 800,
  color: "#64748B", textTransform: "uppercase", letterSpacing: "0.5px",
  borderBottom: "2px solid #E7EAF0", background: "#F8FAFC", whiteSpace: "nowrap",
};

const TD_STYLE = {
  padding: "10px 14px", fontSize: "0.83rem", color: "#0F172A",
  borderBottom: "1px solid #EEF2F7", verticalAlign: "middle", whiteSpace: "nowrap",
};

const PayrollCalendarModal = ({ isOpen, onClose }) => {
  // Only runs still to come — a payment date already passed is not actionable.
  const rows = useMemo(() => upcomingCycles(), []);

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg" centered contentClassName="iv-form-modal-content">
      <ModalHeader toggle={onClose} style={{
        borderBottom: "1px solid #EEF2F7", padding: "16px 24px 14px",
        background: "#fff", borderRadius: "14px 14px 0 0",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <div style={{
            width: 46, height: 46, borderRadius: 12, flexShrink: 0, background: BLUE,
            display: "flex", alignItems: "center", justifyContent: "center",
            boxShadow: "0 4px 12px rgba(37,99,235,0.3)",
          }}>
            <FeatherIcon icon="calendar" size={20} color="#fff" />
          </div>
          <div style={{ fontSize: "1.1rem", fontWeight: 800, color: "#0F172A", lineHeight: 1.2 }}>
            Monthly Payables Calendar
          </div>
        </div>
      </ModalHeader>

      <ModalBody style={{ padding: "20px 26px", background: "#fff" }}>
        <div style={{ border: "1px solid #E7EAF0", borderRadius: 12, overflow: "hidden" }}>
          <div style={{ overflowX: "auto", maxHeight: "58vh" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 560 }}>
              <thead>
                <tr>
                  <th style={TH_STYLE}>Month</th>
                  <th style={TH_STYLE}>Submit By</th>
                  <th style={TH_STYLE}>Approve By</th>
                  <th style={{ ...TH_STYLE, background: "#FEF9C3" }}>Payment Date</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((c) => (
                  <tr key={c.paymentDate}>
                    <td style={{ ...TD_STYLE, fontWeight: 700 }}>{c.month}</td>
                    <td style={TD_STYLE}>{formatCycleDate(c.submitBy)}</td>
                    <td style={TD_STYLE}>{formatCycleDate(c.approveBy)}</td>
                    <td style={{ ...TD_STYLE, fontWeight: 700 }}>{formatCycleDate(c.paymentDate)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div style={{
          display: "flex", gap: 12, alignItems: "flex-start", marginTop: 14,
          background: "#FFFBEB", border: "1px solid #FDE68A", borderRadius: 12,
          padding: "12px 16px",
        }}>
          <span style={{
            width: 34, height: 34, borderRadius: 9, background: "#FEF3C7", flexShrink: 0,
            display: "inline-flex", alignItems: "center", justifyContent: "center",
          }}>
            <FeatherIcon icon="info" size={15} color="#D97706" />
          </span>
          <div style={{ fontSize: "0.78rem", color: "#92400E", lineHeight: 1.55 }}>
            {CALENDAR_RULE_NOTE}
          </div>
        </div>
      </ModalBody>

      <ModalFooter style={{
        borderTop: "1px solid #E9EEF5", padding: "12px 24px",
        background: "#F8FAFC", borderRadius: "0 0 14px 14px",
      }}>
        <button
          type="button"
          onClick={onClose}
          style={{
            height: 42, fontWeight: 600, fontSize: "0.85rem", borderRadius: 10,
            padding: "0 22px", background: "#fff", border: "1px solid #E2E8F0", color: "#334155",
            cursor: "pointer",
          }}
        >
          Close
        </button>
      </ModalFooter>
    </Modal>
  );
};

export { PayrollCalendarModal };
